// import URI from 'urijs';

const gridBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
};

$(function () {

    // menu
    (function () {
        const $menu = $('.mod_navigation');
        const $mobileMenuPlaceholder = $('.mobile-menu-placeholder');
        const $mobileMenu = $menu.clone();

        // mobile menu
        $mobileMenu.removeClass();
        $mobileMenu.addClass('mobile-main-menu')
        $mobileMenuPlaceholder.append($mobileMenu);

    }());


    /**
     * Burger menu
     */
    $('header').each(function () {
        const $container = $(this);

        const $burger = $container.find('.burger');
        $burger.addClass('closed');
        const $navigation = $('.mobile-menu-placeholder');
        $navigation.hide();
        $burger.on('click',  function () {
            $navigation.slideToggle();
            $burger.toggleClass('closed opened');
        });

        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 40) {
                $container.addClass('smaller');
            } else {
                $container.removeClass('smaller');
            }
        });
    });

    /**
     * Wrap rows around elements
     */
    $(':not(.wrap-row) + .wrap-row, * > .wrap-row:first-of-type').each(function () {
        $(this).nextUntil(':not(.wrap-row)').addBack().wrapAll('<div class="row" />');
    });
    $('.wrap-single-row').each(function () {
        if (!$(this).hasClass('.wrap-row') && !$(this).parent('.row').length) {
            $(this).wrap('<div class="row" />');
        }
    });

    /**
     * Accordion
     */

    $('.accordion').each(function () {
        const $element = $(this);
        $(this).addClass('closed');

        const $header = $(this).find('.accordion-header');
        const $container = $(this).find('.accordion-content');
        $container.hide();

        $header.on('click', function () {

            const $openElements = $('.accordion.opened');

            if ($element.hasClass('closed')) {
                $container.slideDown('medium');
                $element.toggleClass('closed opened');
            }

            $openElements.find('.accordion-content').slideUp('medium');
            $openElements.toggleClass('closed opened');


        });
    });


    // const $openElements = $('.accordion');
    //

    // //$openContainers.slideToggle('medium');
    // //$openElements.toggle('closed opened')


    /**
     * Smooth scroll anchor clicks
     */
    $('a').each(function () {

        // Return if no hash was found
        const hash = this.hash;
        if (!hash) return;

        // Get href without hash
        const href = this.href.replace(this.hash, '');

        // Get current uri without hash
        const uri = window.location.href.split('#')[0];

        // Check if link leads to another page. Abort if.
        if (uri !== href) return;

        // Find target and add scroll behaviour
        const $target = $(hash);
        if ($target.length) {
            $(this).on('click', function (event) {
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: $target.offset().top - 160,
                }, 600);
            });
        }
    });

    /**
     * Open external links in new window
     */
    $('a').filter('[href^="http"], [href^="https"], [href^="//"]')
        .not('[href*="' + window.location.host + '"]')
        .attr('rel', 'noopener noreferrer')
        .attr('target', '_blank')
        .addClass('external-link');


    /**
     * Accordion Type 1 and 2
     */
    $('.accordion-type-one').each(function () {
        const $element = $(this);
        $(this).addClass('closed');
        const $container = $(this).find('.accordion-type-one-content');
        $container.hide();
        $(this).find('.accordion-type-one-header').click(function () {
            $container.slideToggle('medium');
            $element.toggleClass('closed opened');
        });
    });
    $('.accordion-type-two').each(function () {
        const $element = $(this);
        $(this).addClass('closed');
        const $container = $(this).find('.accordion-type-two-content');
        $container.hide();
        $(this).find('.accordion-type-two-header').click(function () {
            $container.slideToggle('medium');
            $element.toggleClass('closed opened');
        });
    });


    /**
     * Navigation toggle
     */
    $('#header nav > ul').each(function () {
        const $element = $(this);
        const $navItems = $element.find('li.submenu');

        $navItems.each(function () {
            const $navItem = $(this);
            const $toggler = $navItem.find('.nav-arrow');
            const $submenu = $navItem.children('ul');

            if ($navItem.hasClass('active') || $navItem.hasClass('trail')) {
                $navItem.addClass('opened');
            } else {
                $navItem.addClass('closed');
                $submenu.hide();
            }

            $toggler.on('click', function (event) {
                event.preventDefault();
                $navItem.toggleClass('closed opened');
                $submenu.slideToggle(300);
            });

        });

    });


    $('.live-reveal').each(function (){
        const $element = $(this);
        const duration = parseInt($element.data('duration'));
        if (!duration) {
            $element.show();
            return;
        }
        setTimeout(function (){
            $element.slideDown();
        }, duration * 1000);

    });


});
